import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AdminDashboardService } from 'src/app/services/admin-dashboard.service';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-unlock-request',
    templateUrl: './unlock-request.component.html',
    styleUrls: ['./unlock-request.component.scss'],
    standalone: false
})
export class UnlockRequestComponent implements OnInit {
  public accessList: any;
  public showAllUsers: boolean;
  public selectedUser: any;
  public userDetail: boolean;
  public subscription: Subscription;
  public sharedPlan: any;

  constructor(public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private api: AdminDashboardService, public themeService: ThemeService) { }

  async ngOnInit() {
    this.showAllUsers = true
    this.reloadData()
  }

  async reloadData() {
    let data = await this.api.getAccessRequests()
    if (data) {
      this.accessList = data;
    }
  }

  onSelect(dataUser) {
    this.showAllUsers = false;
    this.selectedUser = dataUser;
    this.userDetail = true
  }

  backFromDetailUser() {
    this.showAllUsers = true
    this.userDetail = false
  }

  displayUserData(event) {
    console.log(event, '- User data from child component')
  }
}
